import { h, JSX } from 'preact';
import ObservingComponent from '../componentBases/observingComponent';
import { BoldReportsReportViewerPage } from 'core.frontend';

import '@boldreports/javascript-reporting-controls/scripts/common/bold.reports.common.min';
import '@boldreports/javascript-reporting-controls/scripts/common/bold.reports.widgets.min';
import '@boldreports/javascript-reporting-controls/scripts/data-visualization/ej.chart.min';
import '@boldreports/javascript-reporting-controls/scripts/bold.report-viewer.min';

enum ExportOptions {
    Pdf = 1,
    Word = 2,
    Excel = 4,
    CSV = 8,
    PPT = 16,
    HTML = 32,
    XML = 64,
    Doc = 128,
    All = 255
}

enum ToolbarItems {
    Export = 1,
    ExclueExport = 1022,
    All = 1023
}

export interface BoldReportsViewerProps {
    page: BoldReportsReportViewerPage;
}

function isMobileDevice() {
    return (window.innerWidth <= 768) ||
        (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
}

class BoldReportsViewer extends ObservingComponent<BoldReportsViewerProps> {

    public componentDidMount(): void {
        const { page } = this.props;
        const reportParams = page.options.reportParams
        const reportId = page.options.reportId
        const reportServiceUrl = page.reportServiceUrl
        const bearerToken = page.bearerToken

        $('#report-viewer')['boldReportViewer']({
            reportServiceUrl: reportServiceUrl,
            reportPath: reportId,
            parameters: reportParams,
            serviceAuthorizationToken: bearerToken,
            exportSettings: {
                exportOptions: ExportOptions.Pdf | ExportOptions.Excel
            },
            toolbarSettings: {
                items: isMobileDevice() ? ToolbarItems.ExclueExport : ToolbarItems.All
            }

            // ajaxBeforeLoad: function (args) {
            //     args.headers = args.headers || {};
            //     args.headers["Authorization"] = bearerToken;
            // }
        });
    }

    public render({ }: BoldReportsViewerProps): JSX.Element {

        return (
            <div style={{
                width: '100% !important',
                height: '900px',
                minHeight: '100%',
                position: 'absolute'
            }}
                id="report-viewer">
            </div>
        );
    }
}

export default BoldReportsViewer;
